export const definePolyfills = () => {
	// Polyfills not provided by the browser should go here
	// Function may be called several times
};
export default definePolyfills;
